import React, { Component } from 'react';
import { Modal, Button, Form, Input, message } from 'antd';
import './style.less';
import send from '../util/request';
import { language } from './language';

const $t = (key) => language.zh[key] || key;
const FormItem = Form.Item;
const layout = {
	labelCol: {
		span: 4,
	},
	wrapperCol: {
		span: 18,
	},
};

class CpChangePassword extends Component {
	formRef = React.createRef();

	handleCancel = () => {
		const { resetFields } = this.formRef.current;
		const { hideModal } = this.props;
		resetFields();
		hideModal();
	}

	submit = () => {
		const { submitModal } = this.props;
		const { validateFields } = this.formRef.current;
		validateFields().then(res => {
			send({
				url: '/ipp/user/reset-password',
				method: 'POST',
				data: {
					password: res.password,
					new_password: res.new_password,
					re_new_password: res.re_new_password
				}
			}).then(res => {
				if (res.data && res.data.code === 0) {
					message.success(res.data.msg || $t('Password changed successfully'), 0.5, () => {
						submitModal();
					});
				} else {
					message.error(res.data.msg);
				}
			});
		});
	}

	validateToNewPassword = async (_, value) => {
		if (!value) {
			return Promise.resolve();
		}
		if (value.length < 6) {
			return Promise.reject(new Error($t('At least 6 characters')));
		}
		const invalidChars = [...new Set(value.replace(/[A-Za-z0-9!@#$_\-*]/g, ''))];
		if (invalidChars.length > 0) {
			return Promise.reject(new Error($t('Invalid character: ') + invalidChars.join(' ')));
		}
		if (!(/^[A-Za-z0-9!@#$_*-]{6,16}$/.test(value) && [/[a-z]/, /[A-Z]/, /\d/, /[!@#$_*-]/].filter(r => r.test(value)).length >= 3)) {
			return Promise.reject(new Error($t('6-16 characters, must include at least 3 of: uppercase letters, lowercase letters, numbers, or symbols')));
		}
		return Promise.resolve();
	}
	compareToFirstPassword = (rule, value) => {
		const { getFieldValue } = this.formRef.current;
		if (!value || getFieldValue('new_password') === value) {
			return Promise.resolve();
		}
		return Promise.reject(new Error($t('Passwords Do Not Match')));
	}

	render() {
		return (
			<Modal
				title={$t('Change Password')}
				open={true}
				width={630}
				maskClosable={false}
				wrapClassName="address-modal"
				centered
				footer={[
					<Button
						key="submit"
						type="primary"
						onClick={this.submit}
						htmlType="submit"
						style={{ width: 200, height: 40 }}>
						{$t('Save')}
					</Button>
				]}
				onCancel={this.handleCancel}
			>
				<Form
					{...layout}
					ref={this.formRef}
				>
					<FormItem
						label={$t('Current Password')}
						name="password"
						rules={[
							{
								required: true,
								message: $t('Please Enter Current Password'),
							},
						]}
					>
						<Input.Password placeholder={$t('Please Enter Current Password')} />
					</FormItem>
					<FormItem
						label={$t('New Password')}
						name="new_password"
						rules={[
							{
								required: true,
								message: $t('Please Enter New Password'),
							},
							{
								validator: this.validateToNewPassword
							}
						]}
					>
						<Input.Password placeholder={$t('Please Enter New Password')} />
					</FormItem>
					<FormItem
						label={$t('Confirm New Password')}
						name="re_new_password"
						rules={[
							{
								required: true,
								message: $t('Please Confirm New Password')
							},
							{
								validator: this.compareToFirstPassword
							}
						]}
					>
						<Input.Password placeholder={$t('Please Confirm New Password')} />
					</FormItem>
				</Form>
			</Modal>
		);
	}
}
export default CpChangePassword;